<template>
  <el-collapse-item :title='"Chip " + chip.id + " " + getLastTestResult(chip)'>
    <h4 v-for="(pos,ipos) in chip.positions">Position {{pos.position.X}}x{{pos.position.Y}} to corrected {{pos.corrected_position.X}}x{{pos.corrected_position.Y}}</h4>
    <div v-if="chip.tests.length > 0">
      <h4>Tests</h4>
      <el-table :data='chip.tests'>
        <el-table-column label="Date" width="190">
          <template slot-scope="scope">
            <span>{{ formatTestTime(scope.row.timestamp) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Type" width="120">
          <template slot-scope="scope">
            <span>{{ formatTestType(scope.row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Timespan" width="100">
          <template slot-scope="scope">
            <span>{{ formatTestTimespan(scope.row.timespan) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Result" width="100">
          <template slot-scope="scope">
            <span>{{ formatResult(scope.row) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="getCodes && getCodes.length > 0">
      <h4>Codes</h4>
      <el-table :data='getCodes'>
        <el-table-column prop='type' label="Type" width="100">
        </el-table-column>
        <el-table-column prop='data' label="Data" width="350">
        </el-table-column>
      </el-table>
    </div>
  </el-collapse-item>
</template>

<script>
import { DateTime } from 'luxon'
var DTFMT = Object.assign({ timeZoneName: 'short' }, DateTime.DATETIME_SHORT_WITH_SECONDS)

export default {
  name: 'chip-data',
  props: {
    chip: Object
  },
  methods: {
    getLastTestResult( chip ){
      if( !chip.tests || chip.tests.length === 0 ){
        return ''
      }
      for( var i = chip.tests.length - 1; i >= 0; i--) {
        if( chip.tests[i].type !== 'validate' ) {
          continue
        }
        return `(state ${chip.tests[i].result})`
      }
    },
    formatTestType( tt ){
      switch( tt ) {
        case 'validate':
          return 'validation'
        case 'check_empty':
          return 'socket empty'
      }
      return tt
    },
    formatTestTime( tt ){
      return DateTime.fromISO(tt).toLocaleString(DTFMT)
    },
    formatTestTimespan( ts ){
      var secs = Math.ceil(ts / 1000)
      var mins = Math.floor(secs / 60.0)
      return `${mins}m ${secs - mins * 60}s`
    },
    formatResult( row ){
      if( row.fail_tray.length > 0 ){
        return `${row.result} (${row.fail_tray})`
      }
      return row.result
    }
  },
  computed: {
    getCodes() {
      var c = []
      this.chip.recons.forEach((r) => {
        r.codes.forEach((code) => {
          c.push(code)
        })
      })
      return c
    }
  }
}
</script>



// WEBPACK FOOTER //
// chip-data.vue?5c38f6b2